import { ElementHTML } from '@helpers/helper.rendering'
import useQueryProperties from '@hooks/useQueryProperties'
import { Link } from 'gatsby'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Property, RealEstateDataPageComponentData } from 'types'

const Summary_Props_4 = (props: RealEstateDataPageComponentData) => {
  const {
    global_data,
    title,
    titleElement,
    titleColor,
    backgroundColor,
    button,
    paragraphs,
    paragraphElement,
  } = props
  const tokkoKey = global_data.pageConfig.keys.tokko
  const icons: string = global_data.pageConfig.design.icons
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const [isMounted, setIsMounted] = useState(false)

  const { data: allProperties, isLoading: isLoadingProperties } = useQueryProperties({
    filters: {
      location: [],
      type: [],
      operation: '',
      environments: '',
      is_starred_on_web: true,
      bedrooms: '',
      age: '',
      address: '',
      producer_id: '',
      price: {},
      environments_types: [],
      generals: [],
      services: [],
      specials: [],
    },
    tokkoKey,
  })

  const propCardId = global_data.content?.cardsProperties?.type_id ?? '1'
  const CardProperty = require(`@components/cardsProperties/${propCardId}`)?.default

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    isMounted && (
      <section
        className={`p-y-config ${
          !isLoadingProperties &&
          (allProperties?.objects?.length === 0 || allProperties === undefined)
            ? ' d-none'
            : ''
        }`}
        style={backgroundColor ? { backgroundColor: backgroundColor } : {}}
        id="last-props"
      >
        <Container fluid>
          <Row>
            <Col
              xs={12}
              lg={4}
              className="d-flex flex-column justify-content-center align-items-start"
            >
              <ElementHTML
                children={title ?? ''}
                elementType={titleElement ?? 'h2'}
                style={titleColor ? { color: titleColor } : {}}
                className="mb-5"
              />
              {paragraphs?.map((paragraph, index) => (
                <ElementHTML
                  key={index}
                  children={paragraph}
                  elementType={paragraphElement || 'h5'}
                />
              ))}
              <Link
                className={'btn btn-primary border w-auto mt-3 d-none d-lg-block'}
                to={button?.link ?? '/'}
              >
                {button?.value ?? 'VER TODAS LAS PROPIEDADES'}
                <i className={`icon-arrow-stick ms-4 ${iconsStyle}`}></i>
              </Link>
            </Col>
            {isLoadingProperties
              ? [1, 2].map((prop) => (
                  <Col
                    xs={12}
                    lg={4}
                    key={prop}
                    className="mt-5 mt-lg-0"
                  >
                    <CardProperty
                      {...props}
                      skeleton={true}
                    />
                  </Col>
                ))
              : allProperties?.objects?.slice(-2)?.map((prop: Property, index: number) => (
                  <Col
                    xs={12}
                    lg={4}
                    key={index}
                    className="mt-5 mt-lg-0"
                  >
                    <CardProperty
                      {...props}
                      key={index}
                      basic={true}
                      property={prop}
                      global_data={global_data}
                    />
                  </Col>
                ))}
          </Row>
          <Link
            className={'btn btn-primary border w-auto mt-3 d-block d-lg-none'}
            to={button?.link ?? '/'}
          >
            {button?.value ?? 'VER TODAS LAS PROPIEDADES'}
            <i className={`icon-arrow-stick ms-4 ${iconsStyle}`}></i>
          </Link>
        </Container>
      </section>
    )
  )
}
export default Summary_Props_4
